import {
    createUserField,
    editUserField,
    createUserFieldValidation,
    editUserFieldValidation,
} from 'constants/FormField/createUserField'
import useFromFieldWithAccount from 'logic/useFromFieldWithAccount'

const useUsers = () => {
    const {fieldsCreate, fieldsEdit, isLoading} = useFromFieldWithAccount({
        fieldsCreate: createUserField,
        fieldsEdit: editUserField,
        withoutAccount: true,
    })

    return {
        fieldsCreate,
        fieldsEdit,
        isLoading,
        createValidationSchema: createUserFieldValidation,
        editValidationSchema: editUserFieldValidation,
    }
}

export default useUsers
